export const toggleSet = (set: Set<string>, value: string, add: boolean) => {
  const newSet = new Set(set);
  add ? newSet.add(value) : newSet.delete(value);
  return newSet;
};
